
import axios from "axios";
import store from '../../store/store';
import { i18n } from "@/js/i18n.js";

// Flag
let isTokenError = false;

var loadKey = true;
var loadNum = 0;
var loadOverNum = 0;

// 會員權限
axios.defaults.headers.common['permissions'] = localStorage.getItem("staffPermissions");
// X-Csrftoken
axios.defaults.headers.common['X-Csrftoken'] = getCsrfTokenFromCookie();

// let localStorage.getItem("MukiLang") = localStorage.getItem("MukiLang");

const Staff = {
    /**
     * 登入
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    login(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/login', formInfo, {mode}).then(res => {
            return res;
        })
    },
    /**
     * 登出
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    logout(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/logout', formInfo, {mode}).then(res => {
            return res;
        })
    },
    /**
     *
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getInfo(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getInfo', formInfo, {mode}).then(res => {
            return res;
        })
    }
}

const OfflineDS = {
    /**
     * 更新離線檔案(ALL)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    upLoadOfflineData(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/upLoadOfflineData', formInfo, {mode}).then(res => {
            return res;
        })
    },
}

// 售服單
const ServiceSales = {



     /**
     * 取得售服單Badge
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceSaleBadge(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceSaleBadge', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得售服單列表(ALL)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceSaleAll(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceSaleAll', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得售服單列表
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceSales(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceSales', formInfo, {mode}).then(res => {
            return res;
        })
    },
    /**
     * 新增售服單
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceSales(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceSales', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 存儲售服單ProcessingStatus
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceSaleProcessingStatus(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceSaleProcessingStatus', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得售服單(維修時間)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceSaleMaintenanceTimes(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceSaleMaintenanceTimes', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 儲存售服單(維修時間)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceSaleMaintenanceTimes(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceSaleMaintenanceTimes', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 儲存售服單(維修時間-單一自動判定)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    addServiceSaleMaintenanceTimeAuto(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/addServiceSaleMaintenanceTimeAuto', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得售服單(客戶確認)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
      getServiceSaleCuatomerFeedback(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceSaleCuatomerFeedback', formInfo, {mode}).then(res => {
            return res;
        })
    },



    /**
     * 儲存售服單(客戶確認)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceSaleCuatomerFeedback(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceSaleCuatomerFeedback', formInfo, {mode}).then(res => {
            return res;
        })
    },


    /**
     * 取得售服單(客戶確認)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceSaleStaff(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceSaleStaff', formInfo, {mode}).then(res => {
            return res;
        })
    },



    /**
     * 儲存售服單(客戶確認)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceSaleStaff(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceSaleStaff', formInfo, {mode}).then(res => {
            return res;
        })
    },

}


// 售服單(機器)
const ServiceMachines = {

    /**
     * 取得售服單(機器)Badge
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceMachineBadge(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineBadge', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得售服單(機器)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceMachines(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachines', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 新增售服單(機器)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    addServiceMachine(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/addServiceMachine', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 複製售服單(機器)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    copyServiceMachine(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/copyServiceMachine', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 刪除售服單(機器)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    deleteServiceSaleMachine(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/deleteServiceSaleMachine', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 存儲機台ProcessingStatus
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineProcessingStatus(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineProcessingStatus', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得機台Basic
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceMachineBasic(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineBasic', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 存儲機台Basic
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineBasic(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineBasic', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得機台Status
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceMachineStatus(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineStatus', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 存儲機台Status
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineStatus(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineStatus', formInfo, {mode}).then(res => {
            return res;
        })
    },


    /**
     * 取得機台Arrangement
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceMachineArrangement(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineArrangement', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 存儲機台Arrangement
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineArrangement(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineArrangement', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得機台ArrangementFile
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceMachineArrangementFile(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineArrangementFile', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 存儲機台ArrangementFile
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineArrangementFile(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineArrangementFile', formInfo, {mode}).then(res => {
            return res;
        })
    },

     /**
     * 取得機台Fittings
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
     getServiceMachineFittings(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineFittings', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 存儲機台Fittings
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineFittings(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineFittings', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得機台Others
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
     getServiceMachineOthers(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineOthers', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 存儲機台Others
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineOthers(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineOthers', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得機台問題表單
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceMachineProblems(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineProblems', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 存儲機台問題表單
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineProblems(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineProblems', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 移除機台問題表單
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    removeServiceMachineProblems(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/removeServiceMachineProblems', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得機台(受訓對象)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceMachineCourseStudents(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineCourseStudents', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 儲存機台(受訓對象)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineCourseStudents(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineCourseStudents', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得機台(課程計畫)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getServiceMachineCoursePlans(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineCoursePlans', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 儲存機台(課程計畫)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineCoursePlans(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineCoursePlans', formInfo, {mode}).then(res => {
            return res;
        })
    },

     /**
     * 取得機台(課程時程)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
     getServiceMachineCourseTimes(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getServiceMachineCourseTimes', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 儲存機台(課程時程)
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveServiceMachineCourseTimes(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveServiceMachineCourseTimes', formInfo, {mode}).then(res => {
            return res;
        })
    },



}

// 問題單
const Question = {
    /**
     * 取得問題表單
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getQuestions(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getQuestions', formInfo, {mode}).then(res => {
            return res;
        })
    },
}

// MU
const MU = {
    /**
     * 取得MU機台列表
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getMuSurveies(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getMuSurveies', formInfo, {mode}).then(res => {
            return res;
        })
    },
    /**
     * 新增MU機台
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveMuSurveies(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveMuSurveies', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得MuBasics
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getMuBasics(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getMuBasics', formInfo, {mode}).then(res => {
            return res;
        })
    },



    /**
     * 取得MU Survey Equipments
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getMuSurveyEquipment(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getMuSurveyEquipment', formInfo, {mode}).then(res => {
            return res;
        })
    },
    /**
     * 儲存 MU Survey Equipments
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveMuSurveyEquipment(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveMuSurveyEquipment', formInfo, {mode}).then(res => {
            return res;
        })
    },


    /**
     * 取得MU Survey Types
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getMuSurveyType(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getMuSurveyType', formInfo, {mode}).then(res => {
            return res;
        })
    },
    /**
     * 儲存 MU Survey Types
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveMuSurveyType(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveMuSurveyType', formInfo, {mode}).then(res => {
            return res;
        })
    },



    /**
     * 取得MU Survey Labels
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getMuSurveyLabel(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getMuSurveyLabel', formInfo, {mode}).then(res => {
            return res;
        })
    },
    /**
     * 儲存 MU Survey Labels
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    saveMuSurveyLabel(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/saveMuSurveyLabel', formInfo, {mode}).then(res => {
            return res;
        })
    },


    /**
     * 取得MU Equipments
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getMuEquipments(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getMuEquipments', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得MU Types
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
     getMuTypes(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getMuTypes', formInfo, {mode}).then(res => {
            return res;
        })
    },

    /**
     * 取得MU Labels
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
     getMuLabels(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getMuLabels', formInfo, {mode}).then(res => {
            return res;
        })
    },

}

// 取得註解資訊
const Annotations = {
    /**
     * 取得取得註解列表
     * @param {Object} formInfo
     *
     * @return {Object} response
    */
    getAnnotations(formInfo, mode) {
        if (formInfo === undefined) {
            formInfo = {};
        }
        formInfo.language = localStorage.getItem("MukiLang");
        return basePost('/getAnnotations', formInfo, {mode}).then(res => {
            return res;
        })
    },
}

const apiBase = axios.create({
    baseURL: "/api/",
    withCredentials: false,
    headers: {
        Accept: "application/json",
        'Content-Type': 'application/form-data'
    },
    transformRequest: [
        function(data, headers){
            // 多國語系
            headers.common['MukiLang'] =  localStorage.getItem("MukiLang") || 'tw';

            return objToFormData(data)
        }
    ],
    transformResponse: [
        function(res){

            apiBase.defaults.headers.common['X-Csrftoken'] = getCsrfTokenFromCookie();

            try {

                var parsed = JSON.parse(res)
                return parsed;

            }catch(err){

                console.log('err', err)

                f7.dialog.alert('資料發生錯誤', '', () => {
                });
            }
        }
    ],
});

const ErrorMsgDisableHandleArr = [];

apiBase.interceptors.response.use(function (config) {
    const { data } = config;
    loadOverNum +=1 ;

    if (loadOverNum == loadNum) {
        loadKey = false;
        _loading_stop();
    }



    // 處理沐奇自定義的錯誤代碼
    if ( data ) {
        const { res_code } = data;



        // token過期
        switch (res_code) {
            // 登入 token
            case mukiConst.token.INVALID:

                if ( isTokenError ) return

                isTokenError = true;

                baseServiceAlert = f7.dialog.alert(`操作時間過長，請重新登入!`, "", () => {
                    logout()
                });

                break;
            // csr token
            case mukiConst.csrToken.INVALID:

                if ( isTokenError ) return;

                isTokenError = true;

                baseServiceAlert = f7.dialog.alert(`操作時間過長，請重新登入!`, "", () => {
                    logout()
                });

                break;
            default:
                break;
        }

        if ( isTokenError ) {
            return Promise.reject('錯誤');
        }
    }
    if (data.http_code === 999) {
        const staffCode = localStorage.getItem('staffCode');
        if ($('.dialog-inner').length == 0 && staffCode !== null) {
            _alert_custom('提示 Notification', data.message, function () {
                localStorage.removeItem('staffPermissions');
                localStorage.removeItem('staffName');
                localStorage.removeItem('staffCode');
                f7.panel.close();
                _back_page('/login');
            })
        }
    }else{
        return config;
    }
}, function (error) {

    // Do something with request error
    if ( ErrorMsgDisableHandleArr.indexOf(error.config.url) === -1 ) {
        if (error.response) {
            // server responded status code falls out of the range of 2xx
            switch (error.response.status) {
                case 400:
                    if ( error.response.data && error.response.data.Message ) {
                        f7.dialog.alert(error.response.data.Message, "訊息提示", () => {
                        });
                    } else {
                        f7.dialog.alert(`${error.response.status}: 資料來源不存在`, "訊息提示", () => {
                        });
                    }

                    break;
                case 404:
                    if ( error.response.data && error.response.data.Message ) {
                        f7.dialog.alert(error.response.data.Message, "訊息提示", () => {
                        });
                    } else {
                        f7.dialog.alert(`${error.response.status}: 資料來源不存在`, "訊息提示", () => {
                        });
                    }
                    break
                case 500:
                    if ( error.response.data && error.response.data.Message ) {
                        f7.dialog.alert(error.response.data.Message, "訊息提示", () => {
                        });
                    } else {
                        f7.dialog.alert(`${error.response.status}: 內部系統發生錯誤`, "訊息提示", () => {
                        });
                    }
                    break
                default:
                    if ( error.response.data && error.response.data.Message ) {
                        f7.dialog.alert(error.response.data.Message, "訊息提示", () => {
                        });
                    } else {
                        f7.dialog.alert(`${error.response.data.Message}`, "訊息提示", () => {
                        });
                    }
                break
            }
        } else {
            // Something happened in setting up the request that triggered an Error
            if (error.code === 'ECONNABORTED' && error.message && error.message.indexOf('timeout') !== -1) {
                // request time out will be here
                f7.dialog.alert('網路連線逾時，請點「確認」鍵後繼續使用。', "訊息提示", () => {
                });
            } else {
                // shutdonw api server
                f7.dialog.alert('網路連線不穩定，請稍候再試', "訊息提示", () => {
                });
            }
        }
    }

    return Promise.reject(error);
});

function getCsrfTokenFromCookie() {
    let regex = /.*csrf_cookie_name=([^;.]*).*$/;
    return document.cookie.match(regex) === null ? null : document.cookie.match(regex)[1];
}

const setApiMode = (apiBase, mode) => {
    if ( mode === 'dev' ) {
        apiBase.defaults.baseURL = "/api/";
    }
    return apiBase;
}

function baseGet(url, formInfo, mode) {
    return setApiMode(apiBase, mode).get(url, formInfo);
}

function basePost(url, formInfo, mode) {
    if (loadNum == loadOverNum) {
        loadKey = true;
        setTimeout(function () {
            if (loadKey && url != "/getServiceSaleAll" && url != "/upLoadOfflineData") {
                _loading_start();
            }
        },500);
    }
    loadNum +=1 ;
    return setApiMode(apiBase, mode).post(url, formInfo);
}

function basePut(url, formInfo, mode) {
    return setApiMode(apiBase, mode).put(url, formInfo);
}

function basePatch(url, formInfo, mode) {
    return setApiMode(apiBase, mode).patch(url, formInfo);
}

function baseDel(url, formInfo, mode) {
    return setApiMode(apiBase, mode).delete(url, formInfo);
}

// common
const Common = {
    /**
     * 登入
     * @param {Object} formInfo
     * @property {string} formInfo.account - 帳號 (mukidev)
     * @property {string} formInfo.password - 密碼 (123456)
     *
     * @return {Object} response
     * @property {string} response.token - 登入類型 (qq11223455)
     * @property {string} response.member_number - 會員編號 (LA000012)
     */
    login(formInfo, mode) {
        return basePost('/api_common/login', formInfo, mode).then(res => {
            return res;
        })
    },
}

export {
    baseGet,
    basePost,
    basePut,
    basePatch,
    baseDel,

    // ==== API ====
    Staff,
    // Common
    Common,
    Annotations,
    // 銷售單
    ServiceSales,
    // 銷售單(機器)
    ServiceMachines,
    // 問題
    Question,
    // MU
    MU,
    // 離線DB
    OfflineDS
};
